import { render, staticRenderFns } from "./ContentSwipe.vue?vue&type=template&id=2e843d68&scoped=true&"
import script from "./ContentSwipe.vue?vue&type=script&lang=ts&"
export * from "./ContentSwipe.vue?vue&type=script&lang=ts&"
import style0 from "./ContentSwipe.vue?vue&type=style&index=0&id=2e843d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e843d68",
  null
  
)

export default component.exports